/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faCar } from '@fortawesome/free-solid-svg-icons/faCar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function ParkingField (props: FormNumberFieldProps) {
  const { name = 'parking', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'parking_places',
        defaultMessage: 'Places de parking'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faCar}
        />
      )}
      {...others}
    />
  )
}

export default ParkingField
